export const mentoriaService = {
  title: 'Mentoria Individual',
  subtitle: 'Acompanhamento personalizado para sua jornada com IA',
  description: 'Receba orientação individual e personalizada para implementar IA na sua prática docente. Sessões online com especialistas que entendem os desafios reais da sala de aula.',
  image: 'https://public.readdy.ai/ai/img_res/c55e316943bf4f8f3a02e54d801131cb.jpg',
  features: [
    {
      icon: 'ri-user-heart-line',
      title: 'Atendimento Personalizado',
      description: 'Sessões individuais focadas nas suas necessidades específicas'
    },
    {
      icon: 'ri-calendar-schedule-line',
      title: 'Flexibilidade de Horários',
      description: 'Agende suas sessões nos horários que melhor funcionam para você'
    },
    {
      icon: 'ri-roadmap-line',
      title: 'Plano de Desenvolvimento',
      description: 'Criamos um roteiro personalizado para seu crescimento profissional'
    },
    {
      icon: 'ri-chat-follow-up-line',
      title: 'Suporte Contínuo',
      description: 'Acompanhamento entre sessões via WhatsApp'
    }
  ],
  plans: [
    {
      name: 'Mentoria Mensal',
      sessions: '4 sessões',
      duration: '1 hora cada',
      price: 'R$ 497,00',
      features: ['4 sessões de 1h', 'Suporte via WhatsApp', 'Materiais exclusivos', 'Gravação das sessões']
    },
    {
      name: 'Mentoria Trimestral',
      sessions: '12 sessões',
      duration: '1 hora cada',
      price: 'R$ 1.297,00',
      popular: true,
      features: ['12 sessões de 1h', 'Suporte prioritário', 'Materiais exclusivos', 'Gravação das sessões', 'Plano de desenvolvimento personalizado']
    }
  ]
};

export const consultoriaService = {
  title: 'Consultoria Educacional',
  subtitle: 'Transformação digital para sua escola',
  description: 'Assessoria completa para implementação de IA na sua instituição de ensino. Desde o diagnóstico até a formação da equipe, acompanhamos todo o processo de transformação digital.',
  image: 'https://readdy.ai/api/search-image?query=professional%20business%20consulting%20meeting%20school%20administrators%20consultants%20discussing%20strategy%20modern%20conference%20room%20presentation%20screen%20collaborative%20atmosphere%20bright%20natural%20lighting%20clean%20professional%20setting&width=1200&height=800&seq=consult001&orientation=landscape',
  features: [
    {
      icon: 'ri-search-eye-line',
      title: 'Diagnóstico Institucional',
      description: 'Análise completa das necessidades e oportunidades da sua escola'
    },
    {
      icon: 'ri-team-line',
      title: 'Formação de Equipe',
      description: 'Capacitação de professores e gestores para uso efetivo de IA'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Plano Estratégico',
      description: 'Desenvolvimento de estratégia personalizada de implementação'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Acompanhamento',
      description: 'Suporte contínuo durante todo o processo de implementação'
    }
  ],
  process: [
    {
      step: '01',
      title: 'Diagnóstico',
      description: 'Reunião inicial para entender as necessidades e objetivos da instituição'
    },
    {
      step: '02',
      title: 'Planejamento',
      description: 'Desenvolvimento de plano estratégico personalizado'
    },
    {
      step: '03',
      title: 'Implementação',
      description: 'Formação da equipe e implementação das ferramentas'
    },
    {
      step: '04',
      title: 'Acompanhamento',
      description: 'Suporte contínuo e ajustes conforme necessário'
    }
  ]
};